import * as type from "./types"

export const fetchHomepageData = () => {
    return { type: type.HOMEPAGE_REQUEST, payload: null }
}

export const resetHomepageData = () => {
    return { type: type.RESET_HOMEPAGE, payload: null }
}